import {SchemaStepConfig} from 'src/types/form';
import {RegistrationSteps} from 'src/types/enums';
import MobileNumber from './MobileNumber';
import UnverifiedMobileNumber from './UnverifiedMobileNumber';
import Yup from 'src/utils/yup';
import {MobileFormState, MobileNumberForm, UnverifiedMobileNumberForm} from 'src/types/onboarding';
import onControlledSubmit from 'src/components/form/onboarding/MobileNumber/onControlledSubmit';

export const MobileNumberSchema = Yup.object({
  mobile: Yup.string().nullable().notRequired().phoneNumber('Invalid phone number'),
  verificationCode: Yup.string().when(['mobile', 'mobileFormState'], {
    is: (values) =>
      values && Boolean(values.mobile) && values.mobileFormState === MobileFormState.CODE_SENT,
    then: Yup.string()
      .length(4, 'Verification code must be four characters')
      .required('Verification code is required'),
    otherwise: Yup.string().nullable().notRequired(),
  }),
});

export const MobileNumberStepConfig: SchemaStepConfig<MobileNumberForm, void> = {
  schema: MobileNumberSchema,
  Component: MobileNumber,
  pathSuffix: 'mobile',
  key: RegistrationSteps.MOBILE_NUMBER,
  onControlledSubmit,
  // Display only if there the student was referred
  shouldDisplay: (form): boolean => Boolean(form.referralSource),
};

export const UnverifiedMobileNumberSchema = Yup.object({
  mobile: Yup.string().nullable().notRequired().phoneNumber('Invalid phone number'),
});

export const UnverifiedMobileNumberStepConfig: SchemaStepConfig<UnverifiedMobileNumberForm, void> =
  {
    schema: UnverifiedMobileNumberSchema,
    Component: UnverifiedMobileNumber,
    pathSuffix: 'mobile',
    key: RegistrationSteps.MOBILE_NUMBER,
  };

export default MobileNumber;
